module.exports = {
      id: "icon-episode-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-episode",
      toString: function () {
        return this.url;
      }
    }